<template>
    <div id="translator-display-output" class="translator-display-output-content">
        <!-- En-tête label -->
        <div class="mb-1">
            <label for="display-output-text" class="form-label fw-semibold mb-0 pl-0 ml-0" style="font-size: 14px;"
                data-testid="display-output-label">{{
                    label }}</label>
        </div>

        <!-- Chargement -->
        <div v-if="isLoading" id="display-output-loading" class="d-flex align-items-center justify-content-center py-4"
            role="status" data-testid="display-output-loading">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ messages.loading }}</span>
            </div>
            <span class="ms-2 text-muted">{{ messages.loading }}</span>
        </div>

        <!-- Résultat -->
        <div v-else class="d-flex align-items-center">
            <span v-if="translationScore !== null" id="display-output-score" data-testid="display-output-score"
                :class="['badge', 'badge-pill', badgeClass(translationScore), 'me-2', 'flex-shrink-0']">
                {{ formatScore(translationScore) }}
            </span>
            <div id="display-output-text" class="form-control output-text-display flex-grow-1"
                style="height:auto;max-height:15rem;overflow-y:auto;" aria-live="polite"
                :aria-label="messages.ariaLabel" data-testid="display-output-text">
                <span v-if="translatedText" ref="outputText" data-testid="display-output-translated"
                    v-html="highlightedHtml"></span>
                <span v-else class="text-muted" data-testid="display-output-placeholder">{{ messages.placeholder
                    }}</span>
            </div>
        </div>

        <!-- Boutons pouce + copier -->
        <div v-if="translatedText && !isLoading" class="d-flex align-items-center">
            <translator-thumb-vote-output v-model="thumbVote" :show="true" :input-text="inputText"
                :translated-text="translatedText" :highlighted-terms="highlightedTerms"
                :translation-score="translationScore" :model-id="modelId" :direction="direction" />
            <button type="button" id="display-output-copy-btn"
                class="v-icon notranslate v-icon--link mdi mdi-content-copy theme--light primary--text pl-1"
                style="font-size: 1.25rem;" @click="copyToClipboard" data-testid="display-output-copy-btn"
                :aria-label="copied ? messages.copiedButton : messages.copyButton"
                :title="copied ? messages.copiedButton : messages.copyButton">
            </button>
        </div>
    </div>
</template>

<script>
import translatorConfig from '../config/translator.config.js';
import TranslatorThumbVoteOutput from './TranslatorThumbVoteOutput.vue';
import { badgeClass, buildHighlightedHtml, formatScore } from '../utils/translatorUtils.js';
import Store from '../store-translator.js';

export default {
    name: 'TranslatorDisplayOutput',
    components: { TranslatorThumbVoteOutput },
    props: {
        translatedText: {
            type: String,
            default: ''
        },
        highlightedTerms: {
            type: Array,
            default: () => []
        },
        translationScore: {
            type: Number,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: () => translatorConfig.displayOutput.messages.labelDefault
        },
        inputText: {
            type: String,
            default: ''
        },
        modelId: {
            type: String,
            default: null
        },
        direction: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            copied: false,
            thumbVote: null,
            messages: translatorConfig.displayOutput.messages
        }
    },
    computed: {
        highlightedHtml() {
            return buildHighlightedHtml(this.translatedText, this.highlightedTerms)
        }
    },
    methods: {
        badgeClass,
        formatScore,
        async copyToClipboard() {
            const el = this.$refs.outputText
            const text = el ? (el.innerText || el.textContent) : this.translatedText
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text)
                } catch {
                    this.fallbackCopy(text)
                }
            } else {
                this.fallbackCopy(text)
            }
            this.copied = true
            setTimeout(() => { this.copied = false }, 2000)
            Store.setSuccessMessage(this.messages.copiedButton)
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed'
            textarea.style.opacity = '0'
            document.body.appendChild(textarea)
            textarea.focus()
            textarea.select()
            try { document.execCommand('copy') } finally {
                textarea.remove()
            }
        }
    }
}
</script>

<style scoped>
.highlight-term {
    background-color: #fff3cd;
    color: #664d03;
    border-radius: 3px;
    padding: 1px 3px;
    font-weight: 600;
}
</style>
